// DOMAINS
export const US_GRANULAR_PROD_DOMAIN = "https://us.insights.granular.ag";
export const US_GRANULAR_TEST_DOMAIN = "https://us.test.insights.granular.ag";
export const US_GRANULAR_DEV_DOMAIN = "https://us.dev.insights.granular.ag";
export const BR_GRANULAR_DEV_DOMAIN = "https://br.dev.insights.granular.ag";
export const BR_GRANULAR_TEST_DOMAIN = "https://br.test.insights.granular.ag";
export const BR_GRANULAR_PROD_DOMAIN = "https://br.insights.granular.ag";
export const CA_GRANULAR_TEST_DOMAIN = "https://ca.test.insights.granular.ag";
export const CA_GRANULAR_DEV_DOMAIN = "https://ca.dev.insights.granular.ag";
export const CA_GRANULAR_PROD_DOMAIN = "https://ca.insights.granular.ag";
export const API = "/api";
